module.exports = __webpack_public_path__ + "static/media/scheduling.6cd2217f.jpeg";